import React, {useEffect, useState} from "react";
import useDidMount from "../../../hooks/useDidMount";
import CustomModal from "../../../components/CustomModal";
import CustomButton, {IconButton, OutlinedButton} from "../../../components/CustomButton";
import {cloneDeep, isEmpty} from 'lodash';
import Input from "../../../components/form/Input";
import UnitSelector from "./UnitSelector";
import {isInputFiledValid} from "helpers/stringHelper";

export const UpdateAreaFormModal = ({processing, area, isEditingArea, setIsEditingArea, onSubmit}) => {

  const [currentArea, setCurrentArea] = useState(area)

  const isDiscountFormValid = () => {
    return currentArea?.price?.discounts.some((d) => !isInputFiledValid(d.min) || !isInputFiledValid(d.discount_amt));
  };

  const isChargeFormValid = () => {
    return currentArea?.weight?.charges.some((d) => !isInputFiledValid(d.min) || !isInputFiledValid(d.inc_factor) || !isInputFiledValid(d.unit) || !isInputFiledValid(d.rate) || !isInputFiledValid(d.max)
    );
  };

  const isFormValid = () => {
    return !currentArea.name ||
      !currentArea.max_shippable_weight ||
      !currentArea.price.rate ||
      !currentArea.weight.max_shipping_charge ||
      !currentArea.weight.weight_increment_threshold ||
      isChargeFormValid() ||
      isDiscountFormValid()

  }

  const preventNegative = (e) => {
    if (e.keyCode === 189) {
      e.preventDefault();
    }
  }

  return <CustomModal title={`Edit ${currentArea.name}`} loading={processing} showModal={isEditingArea} setShowModal={() => {
    setIsEditingArea(false)
    setCurrentArea({})
  }} button={
    <CustomButton
      children="Update"
      disabled={processing || isFormValid()}
      onClick={() => onSubmit(currentArea)}
    />
  }>
    {isEditingArea ? <div className="h-full">
      <div className="flex space-x-2">
        <Input label="Max Shippable Weight *" placeholder="Ex: 10" type="number"
               defaultValue={currentArea.max_shippable_weight}
               onWheel={(e) => e.target.blur()}
               onChange={(e) => {
                 currentArea.max_shippable_weight = e.target.value
                 setCurrentArea({...currentArea})
               }}
               onKeyDown={preventNegative}
        />
        <Input label="Discount Percentage" placeholder="Ex: 10" type="number"
               onWheel={(e) => e.target.blur()}
               defaultValue={currentArea.discount_percentage}
               onChange={(e) => {
                 currentArea.discount_percentage = e.target.value
                 setCurrentArea({...currentArea})
               }}
               onKeyDown={preventNegative}
        />
      </div>
      <div className="flex space-x-2">
        {/*price section*/}
        <div>
          <h1>Price</h1>
          <Input label="Rate *" placeholder="Ex: 10" type="number" defaultValue={currentArea.price?.rate}
                 onWheel={(e) => e.target.blur()}
                 onChange={(e) => {
                   currentArea.price.rate = e.target.value
                   setCurrentArea({...currentArea})
                 }}
                 onKeyDown={preventNegative}
          />
          <p>Discounts</p>
          <div className="space-y-2">
            {
              currentArea.price?.discounts.map((d, index) =>
                <div key={`update-price-discount-${d.toString()}-${index}`}
                     className="relative p-4 pt-8 mb-4 border bg-secondary-100 rounded-md">
                  {currentArea.price?.discounts.length > 1 && (
                    <div className="absolute top-2 right-2">
                      <IconButton
                        onClick={() => {
                          const newDiscounts = currentArea.price?.discounts.filter(
                            (value) => value !== d
                          );
                          setCurrentArea({...currentArea, price: {...currentArea.price, discounts: newDiscounts}});
                        }}
                      />
                    </div>
                  )}
                  <div className="flex space-x-2">
                    <Input label="Min Amt *" type="number" defaultValue={d.min}
                           onWheel={(e) => e.target.blur()}
                           onChange={(e) => {
                             d.min = e.target.value;
                             setCurrentArea({...currentArea})
                           }}
                           onKeyDown={preventNegative}
                    />
                    <Input label="Max Amt " type="number" defaultValue={d.max} onChange={(e) => {
                      d.max = e.target.value;
                      setCurrentArea({...currentArea})
                    }}
                           onWheel={(e) => e.target.blur()}
                           onKeyDown={preventNegative}
                    />
                    <Input label="Dis. Amt *" type="number" defaultValue={d.discount_amt} onChange={(e) => {
                      if (e.target.value.length === 0)
                        delete currentArea["price"]["discounts"][index]["discount_amt"]
                      else
                        d.discount_amt = e.target.value;
                      setCurrentArea({...currentArea})
                    }}
                           onWheel={(e) => e.target.blur()}
                           onKeyDown={preventNegative}
                    />
                  </div>
                </div>
              )
            }
            {/*add more button*/}
            <div className="flex justify-end">
              <OutlinedButton
                disabled={isDiscountFormValid()}
                onClick={() => {
                  let newOne = {
                    ...currentArea, price: {
                      ...currentArea.price, discounts: [...currentArea.price.discounts, {
                        min: '',
                        max: '',
                        discount_amt: '',
                      }]
                    }
                  }

                  setCurrentArea(newOne);
                }}
              >
                + Add more
              </OutlinedButton>
            </div>
          </div>
        </div>
        <div className="w-1 bg-gray-200"/>
        {/*weight section*/}
        <div>
          <h1>Weight</h1>
          <div className="flex space-x-2">
            <Input label="Max Shipping Charge *" type="number" placeholder="Ex: 10"
                   defaultValue={currentArea?.weight?.max_shipping_charge}
                   onChange={(e) => {
                     currentArea.weight.max_shipping_charge = e.target.value
                     setCurrentArea({...currentArea})
                   }}
                   onWheel={(e) => e.target.blur()}
                   onKeyDown={preventNegative}
            />
            <Input label="Weight Increment Threshold *"
                   type="number"
                   placeholder="Ex: 10" defaultValue={currentArea?.weight?.weight_increment_threshold}
                   onChange={(e) => {
                     currentArea.weight.weight_increment_threshold = e.target.value
                     setCurrentArea({...currentArea})
                   }}
                   onWheel={(e) => e.target.blur()}
                   onKeyDown={preventNegative}
            />
          </div>
          <p>Charges</p>
          <div className="space-y-2">
            {
              currentArea.weight?.charges.map((c, index) =>
                <div key={`update-weight-charge-${c.toString()}-${index}`}
                     className="relative p-4 pt-8 mb-4 border bg-secondary-100 rounded-md">
                  {currentArea.weight?.charges.length > 1 && (
                    <div className="absolute top-2 right-2">
                      <IconButton
                        onClick={() => {
                          const newCharges = currentArea.weight?.charges.filter(
                            (value) => value !== c
                          );
                          setCurrentArea({...currentArea, weight: {...currentArea.weight, charges: newCharges}});
                        }}
                      />
                    </div>
                  )}
                  <div className="flex space-x-2">
                    <Input label="Min Weight *" type="number" defaultValue={c.min} onChange={(e) => {
                      c.min = e.target.value
                      setCurrentArea({...currentArea})
                    }}
                           onWheel={(e) => e.target.blur()}
                           onKeyDown={preventNegative}
                    />
                    <Input label="Max Weight *" type="number" defaultValue={c.max} onChange={(e) => {
                      c.max = e.target.value
                      setCurrentArea({...currentArea})
                    }}
                           onWheel={(e) => e.target.blur()}
                           onKeyDown={preventNegative}
                    />
                    <Input label="Rate *" type="number" defaultValue={c.rate} onChange={(e) => {
                      c.rate = e.target.value
                      setCurrentArea({...currentArea})
                    }}
                           onWheel={(e) => e.target.blur()}
                           onKeyDown={preventNegative}
                    />
                    <Input label="Inc factor *" type="number" defaultValue={c.inc_factor} onChange={(e) => {
                      c.inc_factor = e.target.value
                      setCurrentArea({...currentArea})
                    }}
                           onWheel={(e) => e.target.blur()}
                           onKeyDown={preventNegative}
                    />
                    <UnitSelector
                      onChange={(unit) => {
                        c.unit = unit.value
                        setCurrentArea({...currentArea})
                      }}
                      selectedUnit={c.unit}
                    />
                  </div>
                </div>
              )
            }
            <div className="flex justify-end">
              <OutlinedButton
                disabled={isChargeFormValid()}
                onClick={() => {
                  let newOne = {
                    ...currentArea, weight: {
                      ...currentArea.weight, charges: [...currentArea.weight.charges, {
                        min: '',
                        max: '',
                        rate: '',
                        inc_factor: '',
                        unit: '',
                      }]
                    }
                  }
                  setCurrentArea(newOne);
                }}
              >
                + Add more
              </OutlinedButton>
            </div>
          </div>
        </div>
      </div>
    </div> : <div/>}
  </CustomModal>
}
